import React, { useEffect, useState } from 'react';
import { Modal, DatePicker, Button, message, Alert } from 'antd';
import dayjs from 'dayjs';
import { getRankingMensualApi, getPrimerMesClienteApi } from 'api/kpi';
import RankingDowload from 'PDF/RankingMensual/Dowload';

function RankingMensualModal({ open, onClose, clienteId, clienteNombre }) {
  const [mes, setMes] = useState(null);
  const [primerMes, setPrimerMes] = useState(null);
  const [loadingFetch, setLoadingFetch] = useState(false);
  const [rankingData, setRankingData] = useState(null);

  useEffect(() => {
    if (!open) return undefined;
    setMes(null);
    setRankingData(null);
    setPrimerMes(null);
    let cancelled = false;
    getPrimerMesClienteApi(clienteId)
      .then((res) => {
        if (!cancelled) setPrimerMes(res.data?.primer_mes ?? null);
      })
      .catch(() => {
        if (!cancelled) setPrimerMes(null);
      });
    return () => {
      cancelled = true;
    };
  }, [open, clienteId]);

  const mesActual = dayjs().format('YYYY-MM');

  const disabledDate = (current) => {
    if (!current) return false;
    const ym = current.format('YYYY-MM');
    if (ym >= mesActual) return true;
    if (primerMes && ym < primerMes) return true;
    return false;
  };

  const handleGenerar = async () => {
    if (!mes) {
      message.warning('Selecciona un mes');
      return;
    }
    setLoadingFetch(true);
    try {
      const res = await getRankingMensualApi(clienteId, mes.format('YYYY-MM'));
      setRankingData(res.data);
    } catch (err) {
      message.error(err?.response?.data?.message || 'Error al generar el ranking');
    } finally {
      setLoadingFetch(false);
    }
  };

  const fileName = rankingData
    ? `ranking-${(clienteNombre || 'cliente').toLowerCase().replace(/\s+/g, '-')}-${
        rankingData.periodo.mes
      }.pdf`
    : 'ranking-mensual.pdf';

  const flatData = rankingData
    ? {
        ...rankingData.totales,
        cliente_nombre: rankingData.cliente.nombre,
        mes_legible: rankingData.periodo.mes_legible,
        top_items: rankingData.top_items,
        reincidencia: rankingData.reincidencia,
        por_categoria: rankingData.por_categoria,
        serie_6m: rankingData.serie_6m,
        mantenciones: rankingData.mantenciones,
      }
    : null;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Generar PDF ranking mensual"
      footer={null}
      width={520}
      destroyOnHidden
    >
      {!rankingData ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <p style={{ margin: 0 }}>
            Selecciona el mes calendario cerrado para generar el PDF del ranking de ítems fallados
            del cliente.
          </p>
          <DatePicker
            picker="month"
            value={mes}
            onChange={setMes}
            disabledDate={disabledDate}
            placeholder="Seleccionar mes"
            style={{ width: '100%' }}
          />
          {primerMes && (
            <small style={{ color: '#7f8c8d' }}>Primera mantención del cliente: {primerMes}</small>
          )}
          <Button
            type="primary"
            onClick={handleGenerar}
            disabled={!mes}
            loading={loadingFetch}
            block
          >
            Generar
          </Button>
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '16px 0' }}>
          {rankingData.totales.total_mantenciones === 0 && (
            <Alert
              type="info"
              showIcon
              message="Sin datos para el período seleccionado"
              description="El PDF se genera igual con los campos vacíos."
              style={{ marginBottom: 16, textAlign: 'left' }}
            />
          )}
          <RankingDowload data={flatData} config={{}} fileName={fileName} />
          <div style={{ marginTop: 16 }}>
            <Button onClick={() => setRankingData(null)}>Elegir otro mes</Button>
          </div>
        </div>
      )}
    </Modal>
  );
}

export default RankingMensualModal;
